var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeploymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M33 2H22.1a1 1 0 0 0 0 2h8.53l-8.82 9a1 1 0 1 0 1.43 1.4L32 5.46v8.44a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Z",
    className: "clr-i-outline clr-i-outline-path-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m11.54 10.73l-9 5.17a1 1 0 0 0-.5.87v11a1 1 0 0 0 .5.87l9 5.15a1 1 0 0 0 1 0l9-5.15a1 1 0 0 0 .5-.87v-11a1 1 0 0 0-.5-.87l-9-5.17a1 1 0 0 0-1 0ZM11 31.08l-7-4v-8.64l7 4ZM12 21l-7.19-4.13L12 12.78l7.21 4.12Zm8 6.09l-7 4v-8.65l7-4Z",
    className: "clr-i-outline clr-i-outline-path-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploymentIcon);
export default __webpack_public_path__ + "static/media/DeploymentIcon.fa9c5295ef995a016d17897973cc7360.svg";
export { ForwardRef as ReactComponent };